export default __webpack_public_path__ + "phone.c8374e.png";